<template>
  <div class="p-3 bg-white">
    <shared-edit-message-template :categories="categoryOptions" @updateMessageTemplateSuccess="updateMessageTemplateSuccess"></shared-edit-message-template>
    <div class="text-center">
      <vs-button id="editTemplateButton" class="m-2" color="primary" type="filled" @click.prevent="updateMessageTemplate">{{ $t('save') }}</vs-button>
      <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancel">{{ $t('cancel') }}</vs-button>
    </div>
  </div>
</template>

<script>
import Template from '@/models/Template'
import SharedEditMessageTemplate from '@/views/Shared/Messages/Templates/Edit'
import { EventBus } from '@/../eventbus'

export default {
  name: 'Window.Messages.Templates.Edit',
  components: {
    SharedEditMessageTemplate
  },
  data () {
    return {
      categoryOptions: [],
      templateId: ''
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    async initData () {
      try {

        this.templateId = this.$route.params.id
        const response = await Template.all()
        this.categoryOptions = response.data.meta.options.categories

        // TODO: Create new API for these options: clientGroupOptions, clientLevelOptions and customFields
        const template = await Template.view({ id: this.templateId })
        EventBus.$emit('editMessageTemplate', template.data.template)

      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }
    },
    updateMessageTemplate () {
      EventBus.$emit('updateMessageTemplate')
    },
    updateMessageTemplateSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_message_templates_table')
      window.close()
    },
    cancel () {
      this.$windowOpenerHelper.notifyOpener('reload_message_templates_table')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
